import React from "react";
import logo from "../assets/logo.png";

export default function Logo({ height }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: height || "auto",
        }}
      >
        <img
          src={logo}
          alt="Pansuriya Impex Logo"
          style={{
            objectFit: "contain",
            height: height || "100%",
            width: "auto",
          }}
        />
      </div>
    </div>
  );
}
